import React, { useState } from 'react'
import { Dialog, Grid, DialogTitle, IconButton, Typography, Tooltip } from '@mui/material'
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material'
import GroupingSetting from './components/GroupingSetting'
import HidingSetting from './components/HidingSetting'
import { Box } from '@mui/system'
import FreezingSetting from './components/FreezingSetting'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'

function TableSetting({
  columns,
  columnsForGroupBy,
  selectTotalArr,
  groupByColumns,
  setGroupByColumns,
  hiddenColumns = [],
  setHiddenColumns,
  activityColumns,
  hiddenActivityColumns = [],
  setHiddenActivityColumns,
  accumulatedColumn,
  setAccumulatedColumn,
  color,
  handleFreeze,
  freezeColumnId,
  showFreezing = true,
}) {
  const [settingDialog, setSettingDialog] = useState(false)

  const hiddenActivityColumnsArray = Array.isArray(hiddenActivityColumns)
    ? hiddenActivityColumns
    : []

  const hiddenColumnsArray = Array.isArray(hiddenColumns) ? hiddenColumns : []

  const activityColumnsArray = Array.isArray(activityColumns) ? activityColumns : []
  const ColumnsArray = Array.isArray(columns) ? columns : []
  const combinedColumns = [...ColumnsArray, ...activityColumnsArray]
  const shouldHideControls = activityColumns === undefined && hiddenActivityColumnsArray.length == 0

  return (
    <div>
      <Tooltip
        className="hide-columntable"
        title={
          <>
            {hiddenColumnsArray.length == 0 ? (
              <div
                className="fontsize12 fontWeight600 textprimaryblue"
                style={{ paddingBottom: 10 }}
              >
                No columns hidden
              </div>
            ) : (
              <div>
                {hiddenColumnsArray.length} columns hidden
                <ul style={{ paddingLeft: 15 }}>
                  {ColumnsArray.filter((it) =>
                    hiddenColumnsArray.includes(+it.path.split('__')[0])
                  ).map((rd) => (
                    <li key={rd.path}>{rd.name}</li>
                  ))}
                </ul>
              </div>
            )}

            {showFreezing && hiddenActivityColumnsArray.length == 0 ? (
              <div>No activity hidden</div>
            ) : (
              showFreezing && (
                <div className="fontsize12 fontWeight600">
                  {hiddenActivityColumnsArray.length} Activity hidden
                  <ul style={{ paddingLeft: 15 }}>
                    {activityColumnsArray
                      .filter((it) => hiddenActivityColumnsArray.includes(+it.path.split('__')[0]))
                      .map((rd) => (
                        <li key={rd.path}>{rd.name}</li>
                      ))}
                  </ul>
                </div>
              )
            )}

            {showFreezing &&
              shouldHideControls &&
              (freezeColumnId?.length === 0 ? (
                <div>No columns freeze</div>
              ) : (
                showFreezing && (
                  <div>
                    freeze columns upto
                    <ul style={{ paddingLeft: 15 }}>
                      {combinedColumns
                        .filter((it) => freezeColumnId?.includes(+it.path.split('__')[0]))
                        .map((rd) => (
                          <li key={rd.path}>{rd.name}</li>
                        ))}
                    </ul>
                  </div>
                )
              ))}
          </>
        }
      >
        <IconButton
          sx={{ padding: '0px' }}
          size="small"
          color={color}
          onClick={() => {
            setSettingDialog(true)
          }}
        >
          <SettingsOutlinedIcon sx={{ fontSize: '19px', color: '#41464a' }} />
        </IconButton>
      </Tooltip>
      <Dialog
        className="common-dialog"
        open={settingDialog}
        onClose={() => {
          setSettingDialog(false)
        }}
        maxWidth="l"
      >
        <DialogTitle
          style={{
            padding: '10px 10px 0px',
            margin: '10px 15px 0px',
            boxSizing: 'border-box',
          }}
        >
          <Grid className="d-flex" justifyContent="space-between" alignItems="center">
            <Typography className="fontWeight600 fontsize16" variant="h5">
              Hide Column
            </Typography>
            <IconButton
              align="right"
              onClick={() => {
                setSettingDialog(false)
              }}
              size="large"
            >
              <HighlightOffIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Grid>
        </DialogTitle>

        <Box style={{ margin: '10px 24px' }}>
          <HidingSetting
            columns={columns}
            hiddenColumns={hiddenColumnsArray}
            setHiddenColumns={setHiddenColumns}
          />
          {!shouldHideControls && (
            <HidingSetting
              columns={activityColumns}
              hiddenColumns={hiddenActivityColumnsArray}
              setHiddenColumns={setHiddenActivityColumns}
              isActivity={true}
            />
          )}
          {selectTotalArr && (
            <GroupingSetting
              columns={columnsForGroupBy}
              groupByColumns={groupByColumns}
              setGroupByColumns={setGroupByColumns}
              accumulatedColumn={accumulatedColumn || []}
              setAccumulatedColumn={setAccumulatedColumn}
              selectTotalArr={selectTotalArr}
            />
          )}
          {showFreezing && shouldHideControls && (
            <FreezingSetting
              hiddenColumns={hiddenColumnsArray}
              columns={columns}
              handleFreeze={handleFreeze}
              freezeColumnId={freezeColumnId}
            />
          )}
        </Box>
      </Dialog>
    </div>
  )
}

export default TableSetting
